export const AUTHENTICATION_START = '@auth/AUTHENTICATION_START';
export const AUTHENTICATION_SUCCESS = '@auth/AUTHENTICATION_SUCCESS';
export const AUTHENTICATION_FAILED = '@auth/AUTHENTICATION_FAILED';
export const AUTHENTICATION_ANONYMOUS_LOGIN_START = '@auth/AUTHENTICATION_ANONYMOUS_LOGIN_START';
export const AUTHENTICATION_ANONYMOUS_LOGIN_SUCCESS = '@auth/AUTHENTICATION_ANONYMOUS_LOGIN_SUCCESS';
export const AUTHENTICATION_ANONYMOUS_LOGIN_FAILED = '@auth/AUTHENTICATION_ANONYMOUS_LOGIN_FAILED';
export const AUTHENTICATION_LOGOUT_START = '@auth/AUTHENTICATION_LOGOUT_START';
export const AUTHENTICATION_LOGOUT_SUCCESS = '@auth/AUTHENTICATION_LOGOUT_SUCCESS';
export const AUTHENTICATION_LOGOUT_FAILED = '@auth/AUTHENTICATION_LOGOUT_FAILED';
export const AUTHENTICATION_REFRESH = '@auth/AUTHENTICATION_REFRESH';
export const AUTHENTICATION_EXPIRED = '@auth/AUTHENTICATION_EXPIRED';
//# sourceMappingURL=constants.js.map